/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface UserJobTitleInfoViewModel { 
    userJobTitleId?: number;
    mainDuty?: boolean;
    priority?: number;
    departmentId?: number;
    departmentCode?: string;
    departmentName?: string;
    departmentLevel?: number;
    jobTitleId?: number;
    jobTitleCode?: string;
    jobTitleName?: string;
}